import { formatMessage, formatMessageWithParams } from "./LanguageHelper";

export const getClipboardText = async (): Promise<string> => {
  if (!navigator.permissions) {
    throw new Error("Permissions API is not supported in this browser.");
  }
  // eslint-disable-next-line no-undef
  const result = await navigator.permissions.query({ name: "clipboard-read" as PermissionName });
  switch (result.state) {
    case "granted":
    case "prompt": {
      const clipboardPreview = await navigator.clipboard.readText();
      if (typeof clipboardPreview !== "string" || clipboardPreview.trim() === "") {
        throw new Error(
          formatMessageWithParams("cof.createnewobject.pastsettings.message.error.textnotvalid", {
            clipboardPreview: clipboardPreview,
          })
        );
      }
      return clipboardPreview;
    }
    case "denied":
      throw new Error(formatMessage("cof.createnewobject.pastsettings.message.error.copynotallowed"));
  }
};
